export const GenerationStrategies = [{
  value: 'MANUAL',
  label: 'Manual',
},
{
  value: 'AUTOMATIC',
  label: 'Automatic',
}];